import React from 'react';
import { Field, TextInput } from '../lib/FormControls';

export default function Step5Bank({ form, setField }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Bank Information</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Bank Name" required>
          <TextInput value={form.bank_name} onChange={(e) => setField('bank_name', e.target.value)} />
        </Field>
        <Field label="Routing Number" sensitive required>
          <TextInput
            value={form.routing_number}
            onChange={(e) => setField('routing_number', e.target.value)}
          />
        </Field>
        <Field label="Account Number" sensitive required>
          <TextInput
            value={form.account_number}
            onChange={(e) => setField('account_number', e.target.value)}
          />
        </Field>
      </div>
    </div>
  );
}
